export default {
	/**
	 * FEATURES
	 */

	// enable in [env]
	// "feature_name": ["beta", "prod"],

	disabled: [],
	enabled: ['local', 'dev', 'beta', 'prod']
};
